import React from 'react'
import { Block, SupportersGrid } from '@components'

const DatoCmsSupportersGrid = ({
  paddingTop,
  paddingBottom,
  background,
  ...props
}) => {
  return (
    <Block
      gutters
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
    >
      <SupportersGrid {...props} />
    </Block>
  )
}

export default DatoCmsSupportersGrid
